import React from 'react';
import { CONTACT } from './Constants';
export function Footer() {
  return <footer className="bg-azul-dark text-white pt-16 pb-24 md:pb-8" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-92">
          <div className="lg:col-span-2" data-id="element-93">
            <h3 className="text-xl font-bold mb-4" data-id="element-94">
              Evolución Chile Centros de Rehabilitación
            </h3>
            <p className="text-blue-200 mb-4" data-id="element-95">Chile</p>
            <p className="text-sm text-blue-200 max-w-md leading-relaxed" data-id="element-96">
              La información entregada en esta página es de carácter orientativo
              y no reemplaza una evaluación profesional personalizada. Cada
              proceso debe ser evaluado de acuerdo con la situación particular
              de la persona.
            </p>
          </div>

          <div data-id="element-97">
            <h4 className="text-lg font-semibold mb-4" data-id="element-98">Contacto Directo</h4>
            <ul className="space-y-3" data-id="element-99">
              <li data-id="element-100">
                <a href={CONTACT.whatsappUrl} className="text-blue-200 hover:text-white transition-colors" data-id="element-101">
                  WhatsApp: {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li data-id="element-102">
                <a href={CONTACT.phoneUrl} className="text-blue-200 hover:text-white transition-colors" data-id="element-103">
                  Llamadas: {CONTACT.phoneDisplay}
                </a>
              </li>
              <li data-id="element-104">
                <a href={`mailto:${CONTACT.email}`} className="text-blue-200 hover:text-white transition-colors break-all" data-id="element-105">
                  Email: {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-106">
            <h4 className="text-lg font-semibold mb-4" data-id="element-107">Ubicación Principal</h4>
            <p className="text-blue-200" data-id="element-108">{CONTACT.address}</p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center md:text-left flex flex-col md:flex-row justify-between items-center" data-id="element-109">
          <p className="text-sm text-blue-300" data-id="element-110">
            &copy; {new Date().getFullYear()} Evolución Chile. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}